// export const URL_FORMS = process.env.REACT_APP_API_URL;
// TEST
// export const URL_FORMS = 'docker.btk.modem.by:8023/api/';
export const URL_FORMS = '/api/';
